import { useEffect, useState } from 'react';
import StoreX, { store } from '../../../redux/oldStore';
import Icon, { IconType } from '../../Icon/Icon';
import BranchPortal from './BranchPortal';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ServerResponse } from '../../../utils/Server';

interface IOutsideBranchProps {}

const OutsideBranch = (props: IOutsideBranchProps) => {
  const params = useParams();

  const [branch, setBranch] = useState<string>();
  const [form, setForm] = useState<any>({ branchType: '[sales-site]' });

  useEffect(() => {
    
    let preload = StoreX.GetQueryStringValue('preload');
    if (preload) {
      preloadBranch();
    } else {
      init();
    }
  }, []);

  const preloadBranch = () => {
    // query string params to object
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let params: any = {};
    for (let pair of urlParams.entries()) {
      params[pair[0]] = pair[1];
    }

    let request: any = { ...params };
    store.server
      .postApi<ServerResponse<any>>('../SetupWiz/PreloadBranch', request)
      .then((x) => {
        init();
      })
      .catch((error: any) => {
        console.log('Error:', error);
        init();
      });
  };

  const init = () => {
    let branchType = StoreX.GetQueryStringValue('type');
    if (branchType) {
      setBranch(branchType);
      setForm({ ...form, branchType: branchType });
    } else {
      setBranch('[sales-site]');
    }
  };

  return (
    <>
      {branch && (
        <div className="branch-container-outside">
          <BranchPortal type={branch} />
        </div>
      )}
    </>
  );
};

export default OutsideBranch;
